import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectRace, selectAge, selectBehaviourDesc } from '@store/order/selectors';
import { CHARACTER_TYPE_ENUM_TRANSLATION_KEYS, isCharacterTypeEnum } from '@pages/order/animal-info/CharacterTypeEnum';



const AnimalInfo = () => {
	const { t } = useTranslation('forms');

	const race = useSelector(selectRace);
	const age = useSelector(selectAge);
	const behaviourDesc = useSelector(selectBehaviourDesc);

	return (
		<>
			<div className='order-summary-element'>

				<h2>{t('inputLabels.race')}</h2>

				<div className='summary-property'>
					<p>{race ? race : '-'}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>{t('inputLabels.age')}</h2>

				<div className='summary-property'>
					<p>{age ? age : '-'}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>{t('animalInfo.character.sectionLabel')}</h2>

				<div className='summary-property'>
					<p>{isCharacterTypeEnum(behaviourDesc)
						? t(CHARACTER_TYPE_ENUM_TRANSLATION_KEYS[behaviourDesc])
						: '-'}
					</p>
				</div>

			</div>
		</>
	);
};

export default AnimalInfo;